/**
 * IM 相关 HTTP API
 */
import { request } from '@umijs/max';
import type { GetUserSigRequest, GetUserSigResponse } from './types';

/**
 * 获取腾讯云 IM UserSig（GET /v1/im/usersig）
 *
 * @param params.force_refresh 是否强制刷新 Redis 缓存，默认 false
 * @param params['expire-usersig'] 测试专用：为 true 时额外返回 1 秒有效期的
 *   独立预览签，用于手动验证 UserSig 过期兜底流程。默认不传。
 */
export async function getUserSig(
  params?: GetUserSigRequest,
  options?: { [key: string]: any },
): Promise<GetUserSigResponse> {
  const { force_refresh = false, 'expire-usersig': expireUserSig } =
    params || {};
  return request('/v1/im/usersig', {
    method: 'GET',
    params: {
      force_refresh,
      ...(expireUserSig ? { 'expire-usersig': true } : {}),
    },
    ...(options || {}),
  });
}
